import { BookOpen } from 'lucide-react';
import { CollectionAdmin } from './_P1Common';

export default function AdminSeries() {
  return (
    <CollectionAdmin
      path="series"
      title="Serije članaka"
      subtitle="Skupine povezanih članaka (feljtoni, istraživanja…)"
      icon={BookOpen}
      testid="admin-series"
      fields={[
        { key: 'title', label: 'Naslov serije' },
        { key: 'slug', label: 'Slug' },
        { key: 'description', label: 'Opis', type: 'textarea' },
        { key: 'cover_image', label: 'URL naslovne slike' },
        { key: 'article_slugs', label: 'Slug-ovi članaka (zarezom odvojeni)', type: 'textarea' },
        { key: 'active', label: 'Aktivna', type: 'checkbox' },
      ]}
    />
  );
}
